
















































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import StyleUsageModal from "@/components/styles/modals/StyleUsageModal.vue";
import StyleDeleteModal from "@/components/styles/modals/StyleDeleteModal.vue";
import StyleCopyModal from "@/components/styles/modals/StyleCopyModal.vue";
import ChannelStylesDeleteModal from "@/components/styles/modals/ChannelStylesDeleteModal.vue";
import ChannelStylesCopyModal from "@/components/styles/modals/ChannelStylesCopyModal.vue";
import vSelect from "vue-select";
// service methods
import { getAllChannelStyles } from "@/services/styles/channelStylesService";
// types
import { ChannelStyleFields } from "@/components/styles/fields/stylesFields";
import { ChannelStyle } from "@/services/styles/types";
import { ChannelStyleTypes } from "@/services/channels/types";

@Component({
    components: { StyleUsageModal, vSelect, ChannelStylesDeleteModal, ChannelStylesCopyModal }
})
export default class ChannelStyles extends Vue {
    // local state
    styles: ChannelStyle[] = [];
    fields = ChannelStyleFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // computed
    get filteredData() {
        return this.styles.filter(
            x => (this.searchQuery === "" ? true : x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // actions
    styleUpdateRoute(styleId: string) {
        return {
            name: "updateChannelStyles",
            params: { styleId: styleId }
        };
    }

    deleteStyle(styleId: string, name: string) {
        (this.$refs.styleDeleteModal as any).open(styleId, name);
    }

    copyStyle(id: string, name: string) {
        (this.$refs.styleCopyModal as any).open(id, name);
    }

    // methods
    loadStyles() {
        getAllChannelStyles().then((response: ChannelStyle[]) => {
            this.styles = response;
            this.isBusy = false;
        });
    }

    fetchData() {
        this.isBusy = true;
        this.loadStyles();
    }
}
